import { render, staticRenderFns } from "./FooterLodging.vue?vue&type=template&id=3d5cccde&scoped=true"
import script from "./FooterLodging.vue?vue&type=script&lang=js"
export * from "./FooterLodging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5cccde",
  null
  
)

export default component.exports